'use client';

import { create } from 'zustand';

import type { MiniPdpDrawerOptions, MiniPdpDrawerState } from '../types';

export const useMiniPdpDrawer = create<MiniPdpDrawerState>(set => ({
    isOpen: false,
    productId: null,
    productUrl: undefined,
    source: undefined,
    open: (options?: MiniPdpDrawerOptions) => {
        set({
            isOpen: true,
            productId: options?.productId ?? null,
            productUrl: options?.productUrl,
            source: options?.source,
        });
    },
    close: () => set({ isOpen: false, productId: null, productUrl: undefined, source: undefined }),
}));
